var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: "dl-container clearfix" + (_vm.moreSpace ? " more-space" : ""),
      style: _vm.anchor ? "padding-right: 130px" : "",
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }